module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_MainEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_MainEvent', {

		configure: function () {
			this.EVENTTYPEREFERENCE = {
				1: {name: 'liveshow', wClass: 'Activity_Event_LiveshowEvent'},
				2: {name: 'blogPost', wClass: 'Activity_Event_BlogPostEvent'},
				3: {name: 'message', wClass: ''},
				4: {name: 'trip', wClass: ''},
				5: {name: 'custom', wClass: 'Activity_Event_CustomEvent'},
				6: {name: 'photoset', wClass: 'Activity_Event_PhotosetEvent'},
				7: {name: 'video', wClass: 'Activity_Event_VideoEvent'}
			};

			this.registerOptions('', {
				autoRender: true,
				handleDom: {
					googleCaledar: {
						event: 'click',
						target: '.google-calendar',
						callback: 'handleGoogleCalendar'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.eventId = this.getOption('eventId');
			this.eventType = this.getOption('type');
			this.eventTitle = this.getOption('title');
			this.eventDescription = this.getOption('description');
			this.eventTypedParams = this.getOption('typedParams') || {};
			this.eventOptionsAddToGoogleCalendar = this.getOption('googleLink');
			this.eventOptionsRemindMe = null;
			this.externalEvent = null;
			this.eventStartDate = this.getPrimaryStartDate();
			this.eventStopDate = this.getOption('finishDate');
			this.eventImage = this.getOption('image');

			if (fox.isObject(this.eventTypedParams) && ('_length' in this.eventTypedParams)) {
				this.eventTypedParams.length = this.eventTypedParams._length;
				delete this.eventTypedParams._length;
			}

			if (this.EVENTTYPEREFERENCE.hasOwnProperty(this.eventType)) {
				this.embedWidget(
					this.EVENTTYPEREFERENCE[this.eventType]['name'],
					this.EVENTTYPEREFERENCE[this.eventType]['wClass'],
					{'embed.container': this.requireOption('childContainer')});
			}

			this.registerOptions('.Widget', {
				'hooks.onStartRendering': function () {
					this.setTemplateOptions(this.getParent().getMainProperties());

					return true;
				},
				handleDom: {
					errorImg: {
						target: '.event-image',
						event: 'error',
						callback: function(elt) {
							$(elt).remove();
						}
					}
				}
			})
		
			this.callParent('init', arguments);
		},

		getMainProperties: function () {
			return {
				eventId: this.eventId,
				eventStartDate: this.eventStartDate,
				eventStopDate: this.eventStopDate,
				eventType: this.EVENTTYPEREFERENCE[this.eventType]['name'],
				eventTitle: this.eventTitle,
				eventImage: this.eventImage,
				eventDescription: this.eventDescription,
				eventOptionsAddToGoogleCalendar: this.eventOptionsAddToGoogleCalendar,
				eventOptionsRemindMe: this.eventOptionsRemindMe,
				externalEvent:this.externalEvent,
				eventTypedParams: this.eventTypedParams
			}
		},

		render: function () {
			this.setTemplateOptions(this.getMainProperties());
		
			this.callParent('render', arguments);
		},

		getPrimaryStartDate: function () {
			var primaryStartDate, startDate;

			primaryStartDate = ['video', 'photoset'];

			if (fox.inArray(primaryStartDate, this.EVENTTYPEREFERENCE[this.eventType]['name'])
				&& this.eventTypedParams.hasOwnProperty('startDate')) {
				startDate = this.eventTypedParams.startDate;
			} else {
				startDate = this.getOption('startDate');
			}

			// return startDate;
			return this.getOption('startDate');
		},

		handleGoogleCalendar: function (el) {
			var api = new fox.Api(null, this._wom).method('logger.log');
			api.send({
				index: 'McUserActivity',
				info: {
					type : 5,					
					data: {
						event: 11,
						title: this.eventTitle
					}
				}
			}, false);	
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/mainEvent.js
// module id = 823
// module chunks = 4